<template>
    <div class="alarm_container no_sub_container">
        <div class="light-detail-top">
            <div class="set_alarm_container" >
                <div class="light-top">
                    <h3 v-if="type == 0">{{ $t('light.bullish') }}({{ lightCount }})</h3>
                    <h3 v-if="type == 1">{{ $t('light.standby') }}({{ lightCount }})</h3>
                    <h3 v-if="type == 2">{{ $t('light.bearish') }}({{ lightCount }})</h3>
                    <p>
                        {{ dateConvert }}
                    </p>
                </div>
            </div>
            <!-- search start -->
            <div class="alarm_history_container">
                <div class="Tb_search_wrap alarm support">
                    <form @submit.prevent>
                    <div class="search_wrp">
                        <input
                        type="text"
                        id="search"
                        name="search"
                        class="search_input"
                        :placeholder="$t('alarm.score.searchCoin')"
                        v-model="searchQuery"
                        />
                        <button type="button" class="search_clear" @click="clearSearch"></button>
                    </div>
                    </form>
                </div>
            </div>
            <!-- search end -->
        </div>

        <!-- coin list start -->
        <div class="history_list_warp light-list-wrap">
            <!-- 코인 리스트 api 불러오는 동안 로딩바  start-->
            <div class="subPage_container" v-if="!loadApi || !loadingStatus">
                <div class="loading_spinner">
                    <div class="loading_circle"></div>
                </div>
            </div>
            <!-- 코인 리스트 api 불러오는 동안 로딩바 end -->

            <!-- 권한 없을 경우 안내 멘트 start -->
            <div v-else-if="!okLight" class="ps_nodata next" style="text-align: center">
                <h4 v-if="!promotionPeriod" v-dompurify-html="$t('light.modal')"></h4>
                <h4 v-else v-dompurify-html="$t('alarm.guideMent.access2')"></h4>
            </div>
            <!-- 권한 없을 경우 안내 멘트 end -->

            <!-- 코인 리스트 목록 없을 경우 start -->
            <!-- 검색어 O -->
            <div v-else-if="searchQuery && formattedHistory && formattedHistory.length === 0">
                    <div class="Tb_data_rapid next">
                    <ul>
                        <li v-if="searchQuery" class="search-count">{{ searchCount }}</li>
                    </ul>
                </div>
                <div class="ps_nodata next">
                    {{ $t("light.noData1") }}
                </div>
            </div>

            <!-- 검색어 X -->
            <div v-else-if="formattedHistory && formattedHistory.length === 0"  class="ps_nodata next">
                {{ $t("alarm.rsi.noSignal") }}
            </div>
            <!-- 코인 리스트 목록 없을 경우 end -->


            <!-- 코인 리스트 start -->
            <div class="Tb_data_rapid next" v-else>
                <ul>
                    <li v-if="searchQuery" class="search-count">{{ searchCount }}</li>
                    <li
                    v-for="(history, i) in formattedHistory"
                    :key="i"
                    @click="navigateToChart(history, i)"
                    >
                        <div class="history_list_container">
                            <div class="history_info_wrap">
                                <div class="coin_wrap">
                                    <div class="coin_img">
                                    <img :src="getImagePath(history.coin)"
                                        @error="handleImageError(history.coin, $event)" />
                                    </div>
                                    <div class="coin_name">
                                    <h5>
                                        <span>{{ history.coin }}</span>/{{ history.quote }}
                                    </h5>
                                    <h6 class="txt_time">
                                        {{ history.Date }} {{ history.Time }} {{ history.utcTime }}
                                    </h6>
                                    </div>
                                </div>
                
                            <!-- <div class="sign_box_container" v-if="history.go">
                                <img v-if="type == 0" src="@/assets/images/alarm/light/green_icon.png" alt="icon" />
                                <img v-else-if="type == 1" src="@/assets/images/alarm/light/yellow_icon.png" alt="icon" />
                                <img v-else-if="type == 2" src="@/assets/images/alarm/light/red_icon.png" alt="icon" />
                            </div> -->
            
                            <div class="chart_btn_container">
                                <img src="@/assets/images/dark/icon_chart.svg" v-if="!chartLoad[i]" />
                                <div class="loading_spinner coin_list" v-else>
                                <div class="loading_circle coin_list"></div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </li>
                </ul>
              
            </div>
            <!-- 코인 리스트 end -->

        </div>
        <!-- coin list end -->

    </div>
</template>

<script setup>
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ref, onMounted, onBeforeUnmount, computed, watch } from "vue";

import { chkPermission } from "@/utils/permission.js";

const store = useStore();
const route = useRoute();

const { locale } = useI18n();

// route query로 받은 type
// 0 = bullish
// 1 = standby
// 2 = bearish
const type = computed(() => route.query?.type ?? "0");

// 메인에서 검색어를 넘겨준 경우 상세에서도 유지
const searchQuery = ref(route.query?.search || "");

// 로딩 상태
const loadingStatus = ref(false);

// 차트 버튼 로딩 상태
const chartLoad = ref({});
const chartLoadRe = ref({});

// 유저 번호
const userId = ref();

// store state 연결
const loadApi = computed(() => store.state.lightAlarm.loadApi);
const dateConvert = computed(() => store.state.lightAlarm.dateConvert);

// 현재 type + 검색어 기준으로 보여줄 리스트
const formattedHistory = computed(() => {
  return store.getters["lightAlarm/getHistoryByTypeAndSearch"]({
    type: type.value,
    search: searchQuery.value,
  });
});

// 상단 카운트
const lightCount = computed(() => {
  return store.getters["lightAlarm/getLightCountByType"](type.value);
});

// 검색어 검색 결과 개수
const searchCount = computed(() => {
  const keyword = searchQuery.value.trim();

  if (!keyword) return "";

  return `검색됨 (${formattedHistory.value.length})`;
});

// 검색어 지우기
function clearSearch(event) {
  event.preventDefault();
  searchQuery.value = "";
}

// 코인 이미지 가져오기
function getImagePath(coin) {
  const symbol = `${coin}USDT`;
  const baseSymbol = symbol.replace("USDT", "").toLowerCase();

  try {
    return require(`@/assets/images/coin_logos/${baseSymbol}.svg`);
  } catch {
    return require("@/assets/images/coin_logos/default.svg");
  }
}

// svg 이미지가 없거나 로딩 실패했을 때 png 또는 default 이미지로 대체
function handleImageError(symbol, event) {
  const baseSymbol = String(symbol || "")
    .replace("USDT", "")
    .toLowerCase();

  try {
    event.target.src = require(`@/assets/images/coin_logos/${baseSymbol}.png`);
  } catch {
    event.target.src = require("@/assets/images/coin_logos/default.svg");
  }
}

// 차트 버튼 로딩으로 변경된 거 초기화 함수 
function resetChartLoading() {
  chartLoad.value = {};
  chartLoadRe.value = {};
}

function handlePageShow() {
  resetChartLoading();
}

function handleVisibilityChange() {
  if (!document.hidden) {
    resetChartLoading();
  }
}

// 차트 페이지로 이동
function navigateToChart(coin, idx) {
  chartLoad.value = {};
  chartLoadRe.value = {};

  // reverse 차트면 reverse 로딩 표시
  if (coin.isReverse) {
    chartLoadRe.value[idx] = true;
  } else {
    chartLoad.value[idx] = true;
  }

  const keyword = searchQuery.value.trim();

  // 데이터 구조가 coin.coin일 수도 있고 coin.symbol.coin일 수도 있어서 둘 다 대응
  const symbol = coin.symbol?.coin || coin.coin;

  let url = `${process.env.VUE_APP_CHART_URL}/chart/traffic-chart.php?symbol=${symbol}&exchange_id=1&lang=${locale.value}&type=${type.value}`;

  // 검색어가 있을 때만 search 파라미터 추가
  if (keyword) {
    url += `&search=${encodeURIComponent(keyword)}`;
  }

  window.location.href = url;
}

// 권한 체크 관련 상태
const result = ref(null);
const checkingPermission = ref(true);
const permission = ref(false);
const isLight = ref(false);
const okLight = ref(false);
const alarmPayment = ref(false);
const isPayment = ref(0);
const userPackage = ref(0);
const promotionPeriod = ref(true);
// const chkLight = ref(false);

// 스마트 플랜 권한 체크
async function chkSmartPlan() {
  try {
    result.value = await chkPermission()

    permission.value = result.value.permission;
    isLight.value = result.value.isLight;
    okLight.value = result.value.okLight;
    isPayment.value = result.value.isPayment;
    userPackage.value = result.value.userPackage;
    alarmPayment.value = result.value.alarmPayment;
    promotionPeriod.value = result.value.isLightPromotionPeriod;
    // chkLight.value = promotionPeriod.value ? okLight.value && alarmPayment.value : okLight.value; 
  } finally {
    checkingPermission.value = false;
  }
}

// 로그인 상태 감지
const loginSuccessful = computed(() => {
  return store.state.loginStatus.loginSuccessful;
});

// 최초 로딩 시 필요한 작업
async function loadSuccess() {
  userId.value = localStorage.getItem("userNum");

  // 기존 next-chart 이동 로직 유지
  if (route.query?.symbol && route.query?.exc) {
    const url = `${process.env.VUE_APP_CHART_URL}/chart/next-chart.php?symbol=${route.query?.symbol}&exchange_id=${route.query?.exc}&type=${route.query?.type}&user_id=${userId.value}&lang=${locale.value}&profit=true&time=${route.query?.time}&reverse=false&count=1`;

    window.location.href = url;
    return;
  }

  // 앱 WebView 로딩 완료 전달
  if (window.webkit?.messageHandlers?.loadHandler) {
    window.webkit.messageHandlers.loadHandler.postMessage("Load state changed.");
  }

  if (window.Android?.loadTriggered) {
    window.Android.loadTriggered();
  }

  // 권한 체크
  await chkSmartPlan();
}

// 로그인 성공 시 재호출
watch(loginSuccessful, async (newVal) => {
  if (newVal === true) {
    await loadSuccess();

    // 상세에서도 최신 히스토리 다시 가져오기
    await store.dispatch("lightAlarm/setHistoryList");

    setTimeout(() => {
      loadingStatus.value = true;
    }, 1000);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("pageshow", handlePageShow);
  document.removeEventListener("visibilitychange", handleVisibilityChange);
});

// 페이지 진입 시 호출
onMounted(async () => {
    resetChartLoading();

    window.addEventListener("pageshow", handlePageShow);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    
    await loadSuccess();

    // 상세 페이지 단독 진입도 가능하니까 store 데이터 다시 가져오기
    await store.dispatch("lightAlarm/setHistoryList");

    setTimeout(() => {
        loadingStatus.value = true;
    }, 1000);
});
</script>

<style scoped>
.arrow {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.rotate-down {
  transform: rotate(-180deg);
}

.Tb_data_rapid ul li:active {
    background: transparent !important;
}

.loading_spinner {
    margin: 0;
}

.ps_nodata.next {
    padding-top: 40px;
}

.next-list-info-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.light-top {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    padding: 16px;
}

.light-top h3 {
    color: var(--txt-default-color, #FFF);
    text-align: center;
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 112.5%; 
}

.light-top p {
    color: var(--Grayscale-Gray30, #B9C3CF);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 163.636%;
}

.coin_name h5 {
    color: var(--txt-default-color, #FFF);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 131.25%; 
}

.coin_name span {
    font-weight: 600;
}

.coin_name h6 {
    color: var(--Secondary, #7E8088);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 133.333%; 
}

.light-icon {
    width: 16px;
    height: 16px;
    aspect-ratio: 1/1;
}

.light-icon.green {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(27, 190, 158, 0.50), 0 0 16px 0 rgba(27, 190, 158, 0.80);
}

.light-icon.yellow {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(250, 200, 0, 0.50), 0 0 16px 0 rgba(250, 200, 0, 0.80);
}

.light-icon.red {
    border-radius: 50%;
    box-shadow: 0 0 4px 0 rgba(242, 86, 89, 0.50), 0 0 16px 0 rgba(242, 86, 89, 0.80);
}

.light-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px;
    flex-direction: row !important;
}

.light-list-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-direction: row;
}

.light-top {
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px 20px;
}

.set_alarm_container {
    padding: 12px 0 0;
}

.alarm_history_container {
    top: 100px;
}

.Tb_data_rapid ul li {
    padding: 8px 16px;
    border-bottom: none;
}

.Tb_search_wrap.alarm {
    height: 60px;
}

.Tb_search_wrap {
    padding: 0 16px;
}

.Tb_search_wrap.support {
    top: 110px;
}

.no_sub_container {
    padding-top: 80px;
} 

.light-detail-top {
    position: fixed;
    top: 55px;
    width: 100%;
}

.set_alarm_container, .Tb_search_wrap {
    position: static;
    width: 100%;
}

.Tb_data_rapid ul li.search-count {
    width: 100%;
    border-bottom: solid 1px var(--border-bottom-gray-color);
    flex-direction: row;
    align-items: center;
    padding: 0 16px 12px;
    color: var(--Grayscale-Gray30, #B9C3CF);
    font-size: 11px;
    font-weight: 400;
    line-height: 163.636%;
}



@media (max-width: 550px) {
    .history_list_container .sign_box_container {
        width: 33px;
        margin: 0px 20px;
    }

    .history_list_container .coin_wrap {
        width: 70%;
    }
}

@media (max-width: 400px) {
    .history_list_container .coin_name {
        max-width: none;
    }
}
</style>
